export const faqList = [
  {
    question: '海角社区是什么？',
    answer: '海角社区是国内知名的情感交流与生活分享社区平台，汇聚了来自全国各地的真实用户。在这里，你可以倾诉情感困惑、分享生活故事、结交志同道合的朋友，找到归属感和理解。',
  },
  {
    question: '海角社区是否免费使用？',
    answer: '是的，海角社区完全免费。注册、浏览、发布内容、互动交流等所有基础功能均不收取任何费用。我们致力于为每一位用户提供开放、温暖的交流空间。',
  },
  {
    question: '如何在海角社区发布内容？',
    answer: '注册并登录海角社区账号后，点击首页的「发布」按钮，选择相应的内容板块（情感倾诉、生活故事等），即可撰写并发布你的文章或帖子。内容发布后，其他用户可以浏览、点赞和评论。',
  },
  {
    question: '我的隐私信息安全吗？',
    answer: '海角社区高度重视用户隐私保护。我们采用业界先进的数据加密技术，严格遵循相关法律法规，不会在未经用户授权的情况下向第三方透露任何个人信息。你可以放心地在社区中分享你的故事。',
  },
  {
    question: '可以自己在海角社区删除发布的内容吗？',
    answer: '当然可以。你发布的任何内容都可以随时在个人中心中编辑或删除，所有操作即时生效。我们充分尊重用户对自己内容的控制权。',
  },
  {
    question: '海角社区有移动端App吗？',
    answer: '目前海角社区支持移动端网页访问，你可以在手机浏览器中直接打开我们的网站，体验流畅的移动端页面。App版本正在积极开发中，敬请期待。',
  },
  {
    question: '如何举报不当内容或用户？',
    answer: '如果你在社区中发现不当内容或违规行为，可以通过每篇文章下方的「举报」按钮进行反馈。我们的内容审核团队会在24小时内处理你的举报，并给予回复。',
  },
  {
    question: '海角社区的内容审核标准是什么？',
    answer: '我们倡导积极健康、真诚友善的交流氛围。所有内容需符合国家法律法规及社区管理规范，禁止发布违法、暴力、色情、人身攻击等不良信息。我们希望通过内容审核，为所有用户营造一个安全温馨的交流环境。',
  },
];

export const communityStats = [
  { label: '注册用户', value: '1,286,000+', icon: 'ri-user-line' },
  { label: '每日故事', value: '8,500+', icon: 'ri-article-line' },
  { label: '累计互动', value: '2.3亿+', icon: 'ri-heart-line' },
  { label: '覆盖城市', value: '360+', icon: 'ri-map-pin-line' },
];